import errorBlue from '@/assets/img/errorBlue.png'
import { useActions } from '@/hooks'
import { EventType } from '@/modules/events/types/eventsType'
import {
  useDeletedNotificationsMutation,
  useReadNotificationsMutation,
} from '@/modules/sidebar/services/notificationService'
import { Message } from '@/modules/sidebar/types/notifications'
import ClearIcon from '@mui/icons-material/Clear'
import {
  Box,
  CircularProgress,
  IconButton,
  ListItem,
  ListItemButton,
  ListItemIcon,
} from '@mui/material'
import React, { FC, useRef } from 'react'
import { useNavigate } from 'react-router-dom'

interface Props {
  message: Message
}

const NotificationsItem: FC<Props> = ({ message }) => {
  const navigate = useNavigate()

  const [hovered, setHovered] = React.useState(false)
  const [loading, setLoading] = React.useState(false)
  const isNavigatingRef = useRef(false)

  const { markAsRead, deleteNotification, setFilter } = useActions()

  const [readNotificationsService, { isLoading }] =
    useReadNotificationsMutation()
  const [deleteNotificationsService, { isLoading: isLoadingDelete }] =
    useDeletedNotificationsMutation()

  const getSecondaryAction = () => {
    if (loading || isLoading || isLoadingDelete) {
      return <CircularProgress size={20} />
    }
    if (hovered) {
      return (
        <IconButton
          edge='end'
          onClick={onDeleteNotification}
        >
          <ClearIcon htmlColor='red' />
        </IconButton>
      )
    }
    return null
  }

  const getInfoIcon = () => {
    if (loading || isLoading || isLoadingDelete) {
      return <CircularProgress size={20} />
    }
    if (hovered) {
      return (
        <IconButton
          edge='end'
          onClick={onDeleteNotification}
        >
          <ClearIcon htmlColor='red' />
        </IconButton>
      )
    }
    return null
  }

  const onReadNotification = async () => {
    try {
      await readNotificationsService({
        deviceId: message.deviceId,
        eventId: message.id,
      }).unwrap()
      markAsRead(message.id)
    } catch (e) {}
  }

  const onDeleteNotification = async () => {
    try {
      await deleteNotificationsService({
        deviceId: message.deviceId,
        eventId: message.id,
      }).unwrap()
      deleteNotification(message.id)
    } catch (e) {}
  }

  const { data, eventTypeId, deviceId } = message
  const isPredOch = eventTypeId === 63
  const isOch = eventTypeId === 64
  const isEmptyLink =
    (eventTypeId === 65 || eventTypeId === 66) && deviceId === 0

  const handleClick = (e: any, message: any) => {
    e.preventDefault()
    e.stopPropagation()
    // console.log('deviceId', deviceId, eventTypeId)
    if (isEmptyLink) return
    if (isPredOch || isOch) {
      if (isNavigatingRef.current) {
        return
      }
      isNavigatingRef.current = true
      setFilter([0])
      localStorage.setItem('filterValueDevices', JSON.stringify([0]))
      setTimeout(() => {
        const deviceId = isPredOch ? 16 : isOch ? 17 : 0

        const parsedData = JSON.parse(data)
        const parsedCoordinates = JSON.parse(parsedData?.coordinates)
        const lat = parsedCoordinates?.[0]
        const lng = parsedCoordinates?.[1]
        const year = parsedData?.year
        navigate(`/?deviceId=${deviceId}&year=${year}&lat=${lat}&lng=${lng}`)
        setTimeout(() => {
          isNavigatingRef.current = false
        }, 100)
      }, 1000)
    } else {
      if (isNavigatingRef.current) {
        return
      }
      isNavigatingRef.current = true
      navigate(`/devices/${message.deviceId}`, {
        state: { eventId: message.id, deviceId: message.deviceId },
      })
      setTimeout(() => {
        isNavigatingRef.current = false
      }, 100)
    }
  }
  const handleDoubleClick = (e: any) => {
    e.preventDefault()
    e.stopPropagation()
    handleClick(e, message)
  }
  return (
    <ListItem
      sx={{ p: 0, maxWidth: 455 }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      secondaryAction={getSecondaryAction()}
    >
      <ListItemButton
        onClick={onReadNotification}
        onDoubleClick={handleDoubleClick}
      >
        {message.type === EventType.info && (
          <ListItemIcon>
            <img
              src={errorBlue}
              alt='Info'
              width={30}
            />
          </ListItemIcon>
        )}
        <Box
          display='flex'
          flexDirection='column'
          fontWeight={message.new ? 'bold' : 'normal'}
        >
          <Box>
            {isEmptyLink ? (
              <>{message.moduleName}: </>
            ) : (
              <a
                className={'notification-link'}
                onClick={(e) => handleClick(e, message)}
                style={{ marginRight: 10 }}
              >
                {message.moduleName}:
              </a>
            )}
            <span>{message.message}</span>
          </Box>
          <div style={{ color: 'gray', fontSize: 12 }}>
            {message.createdDate}
          </div>
        </Box>
      </ListItemButton>
    </ListItem>
  )
}

export default NotificationsItem
